{
	"aboutToUpdate": "You're about to update a ",
	"addFinalEdits": "Add Final Edits",
	"affectsAllUsers": "This will affect all users who use this style.",
	"ariaCreateNew": "Create New",
	"description": "Improve your AI Style ({{styleName}}) by adding more edits. Ensure a consistent editing style across your images for the best training results. We will auto-select a set of edits for training and improving your AI Style accuracy. ",
	"editSharedTitle": "Edit Shared AI Style",
	"saveAsNew": "Save as new AI Style",
	"shared": "shared",
	"styleDescription": "{{visibilityLabel}} AI Style ({{name}}).",
	"title": "Add Final Edits to AI Style"
}
